module.exports = __webpack_public_path__ + "static/media/amber-1@3x.0eddcd44.png";